import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive"];
// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template-activatable/src/index.tsx
import React from 'react';
import baseIcon, { navigationActivatableDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NavigationIconBrowserPath = 'M19.5,12.1 C23.0898509,12.1 26,15.0101491 26,18.6 C26,20.2848936 25.3589272,21.8200565 24.3073926,22.9748778 L27.1016195,26.4762445 L25.5383805,27.7237555 L22.7508936,24.2298987 C21.7946282,24.7832713 20.6843021,25.1 19.5,25.1 C15.9101491,25.1 13,22.1898509 13,18.6 C13,15.0101491 15.9101491,12.1 19.5,12.1 Z M22,4 C23.5976809,4 24.9036609,5.24891996 24.9949073,6.82372721 L25,7 L25,11.1 L23,11.1 L23,7 C23,6.48716416 22.6139598,6.06449284 22.1166211,6.00672773 L22,6 L7,6 C6.48716416,6 6.06449284,6.38604019 6.00672773,6.88337887 L6,7 L6,21.1 C6,21.6128358 6.38604019,22.0355072 6.88337887,22.0932723 L7,22.1 L12,22.1 L12,24.1 L7,24.1 C5.40231912,24.1 4.09633912,22.85108 4.00509269,21.2762728 L4,21.1 L4,7 C4,5.40231912 5.24891996,4.09633912 6.82372721,4.00509269 L7,4 L22,4 Z M19.5,14.1 C17.0147186,14.1 15,16.1147186 15,18.6 C15,21.0852814 17.0147186,23.1 19.5,23.1 C21.9852814,23.1 24,21.0852814 24,18.6 C24,16.1147186 21.9852814,14.1 19.5,14.1 Z';
var NavigationIconBrowserActivePath = 'M12.34,23.18 C12.5393816,23.5009455 12.7598672,23.8082891 13,24.1 L7,24.1 C5.34314575,24.1 4,22.7568542 4,21.1 L4,7 C4,5.34314575 5.34314575,4 7,4 L22,4 C23.6568542,4 25,5.34314575 25,7 L25,12.1 C24.710548,11.8478998 24.4030628,11.6172858 24.08,11.41 C20.7132203,9.20891666 16.2639222,9.67254711 13.4232638,12.5204645 C10.5826053,15.3683818 10.1303315,19.8188486 12.34,23.18 Z M25.54,27.72 L22.74,24.22 C21.7581251,24.7977895 20.6392613,25.1016784 19.5,25.1 C18.2614438,25.1101779 17.0462273,24.7629732 16,24.1 C15.5669484,23.8206051 15.1734239,23.4842593 14.83,23.1 C14.5284222,22.796161 14.2602283,22.4609186 14.03,22.1 C13.3670268,21.0537727 13.0198221,19.8385562 13.03,18.6 C13.0354255,15.0240904 15.9241538,12.1219677 19.5,12.1 C20.7385562,12.0898221 21.9537727,12.4370268 23,13.1 C23.3609186,13.3302283 23.696161,13.5984222 24,13.9 C24.3863666,14.2526502 24.7228036,14.6563746 25,15.1 C26.5931935,17.5702436 26.3178398,20.804622 24.33,22.97 L27.13,26.48 L25.54,27.72 Z M19.5,23.1 C21.9829999,23.0945005 23.9945005,21.0829999 24,18.6 C23.9945005,16.1170001 21.9829999,14.1054995 19.5,14.1 C17.5517356,14.1025205 15.8263683,15.35849 15.225319,17.2117251 C14.6242698,19.0649602 15.2840676,21.0944968 16.86,22.24 C17.6260802,22.8002612 18.5509114,23.1015319 19.5,23.1 L19.5,23.1 Z';
var NavigationIcon = baseIcon('NavigationIconBrowser', {
  getPath: _ref => {
    var {
      isActive
    } = _ref;
    return isActive ? NavigationIconBrowserActivePath : NavigationIconBrowserPath;
  },
  styleSheetPropsGetter: (_ref2, designVersion) => {
    var {
      isActive,
      color,
      colorToken,
      colorTokenArgs
    } = _ref2;
    return {
      isActive,
      color,
      designVersion,
      colorToken,
      colorTokenArgs
    };
  },
  defaultStyleSheetGetter: navigationActivatableDefaultStyleSheetGetter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  restOfPropsSanitizer: _ref3 => {
    var {
        isActive
      } = _ref3,
      restOfProps = _objectWithoutProperties(_ref3, _excluded);
    return restOfProps;
  },
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
var NavigationIconBrowser = props => {
  useDeprecationWarning({
    componentName: 'NavigationIconBrowser',
    removalDate: 'v6.0.0'
  });
  return /*#__PURE__*/React.createElement(NavigationIcon, props);
};
NavigationIconBrowser.displayName = 'NavigationIconBrowser';
export default NavigationIconBrowser;
//# sourceMappingURL=index.js.map